import { getContextFromUrl } from 'config/Config';

export const texts = {
    MAX: 'Max. ',
    PESO: ' MB',
    ELIMINAR: 'ELIMINAR',
    TAM: 'Tamaño ',
    TEXTO_DROP: 'Subir Archivo',
}

export const pathIcono = {
    PATH_IMG_PDF: `${getContextFromUrl()}` + 'pdfGris.png',
    PATH_IMG_FOTO: `${getContextFromUrl()}` + 'imgGris.png',
    PATH_IMG_VIDEO: `${getContextFromUrl()}` + 'videoGris.png'
};